export default __webpack_public_path__ + "static/media/1882.e25487ae.png";